import React from 'react';
import ExternalRedirect from './ExternalRedirect';

const App = () => {
  return (
    <div>
      <ExternalRedirect to="https://whatsapp.com/channel/0029Vb1NkqG3bbV4i2ligy2k?follow=true" />
    </div>
  );
};

export default App;
